<template>
  <el-drawer :title="drawerTitle" :visible.sync="localVisible" direction="rtl" size="700px" append-to-body>
    <div class="drawer-wrap">
      <div v-if="loading" class="drawer-loading">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
      <div v-else-if="!dataList.length" class="drawer-empty">
        <i class="el-icon-document"></i>
        <div>暂无站点数据</div>
      </div>
      <template v-else>
        <el-row :gutter="12" class="stat-row">
          <el-col :span="disabledCount > 0 ? 8 : 12">
            <div class="stat-card">
              <div class="stat-num">{{ dataList.length }}</div>
              <div class="stat-label">共计条目</div>
            </div>
          </el-col>
          <el-col :span="disabledCount > 0 ? 8 : 12">
            <div class="stat-card">
              <div class="stat-num success">{{ normalCount }}</div>
              <div class="stat-label">运营中</div>
            </div>
          </el-col>
          <el-col :span="8" v-if="disabledCount > 0">
            <div class="stat-card">
              <div class="stat-num danger">{{ disabledCount }}</div>
              <div class="stat-label">未运营</div>
            </div>
          </el-col>
        </el-row>
        <div v-for="item in dataList" :key="item.stationId" class="dict-item">
          <div class="dict-cell">
            <div class="dict-cell-key">站点</div>
            <div class="dict-cell-val">
              {{ item.stationName }}
            </div>
          </div>
          <div class="dict-cell">
            <div class="dict-cell-key">状态</div>
            <div class="dict-cell-val">
              <dict-tag :options="dict.type.metro_status" :value="item.stationStatus" size="small"/>
            </div>
          </div>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import { listStation } from '@/api/metro/station'

export default {
  dicts: ['metro_status'],
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      localVisible: false,
      loading: false,
      dataList: []
    }
  },
  computed: {
    drawerTitle() {
      return this.row.metroName + this.row.lineName + '站点'
    },
    normalCount() {
      return this.dataList.filter(r => r.stationStatus === '1').length
    },
    disabledCount() {
      return this.dataList.filter(r => r.stationStatus === '0').length
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
    },
    localVisible(val) {
      this.$emit('update:visible', val)
      if (val) {
        this.loadData()
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    loadData() {
      if (!this.row || !this.row.lineCode) return
      this.loading = true
      this.dataList = []
      listStation({ lineCode: this.row.lineCode }).then(response => {
        this.dataList = response.data || []
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.dict-item {
  grid-template-columns: 1fr 1fr;
}
</style>
